<template>
  <!-- <v-layout column :class="['entity_list_item',item.selected ? 'highlighted_event': '']"> -->
  <v-layout column :class="['entity_list_item']">
    <v-flex xs8>
      <h4 class="pl-2 pt-2 fontSize">{{item.name}}</h4>
    </v-flex>
    <v-layout>
      <v-flex xs8>
        <h4 class="pl-2 pt-2">{{item.date}}</h4>
      </v-flex>
      <v-flex xs3>
        <v-tooltip bottom>
          <v-btn class="v-btn-2 appear_as_button" round slot="activator" color="primary" @click="selectEvent(1)">
            <v-icon small dark>edit</v-icon>
          </v-btn>
          <span>{{$translate('EVENT_EDITING')}}</span>
        </v-tooltip>
      </v-flex>
      <v-flex xs3 v-if="$store.getters['auth/partnerId'] == -1">
        <v-tooltip bottom>
          <v-btn class="v-btn-2 appear_as_button" round color="primary" slot="activator" @click="selectEvent(3)">
            <v-icon small dark>chat_bubble_outline</v-icon>
          </v-btn>
          <span>{{$translate('SEND_MESSAGE_TO')}}</span>
        </v-tooltip>
      </v-flex>
      <v-flex xs3>
        <v-tooltip bottom>
          <v-btn
            class="v-btn-2"
            round
            color="primary"
            slot="activator"
            @click="showConfirmationDelete"
          >
            <v-icon small dark>delete</v-icon>
          </v-btn>
          <span>{{$translate('DELETING_EVENT')}}</span>
        </v-tooltip>
      </v-flex>
    </v-layout>
  </v-layout>
</template>

<script>
import CreateEventObject2 from "@/objects/CreateEventObject2";
import AudioLoader from "@/components/media/AudioLoader";
import BaseObject from "@/objects/BaseObject";
import * as dssRequest from "@/api/dssRequest";
import BaseComponent from "./base/BaseComponent.vue";
import { ui_helpers } from "@/shared/ui_helpers";
import appConfig from "../../config/app_config"; // Mandatory to reach the dss objects and other info

export default {
  name: "EntityList",
  extends: BaseComponent,
  mixins: [ui_helpers],
  props: {
    item: Object
  },
  // watch: {
  //   item: {
  //     handler(v) {
  //     },
  //     deep: true
  //   }
  // },
  data() {
    return {
      eventDetail: {},
    };
  },
  methods: {
    selectEvent(tab = 1) {
      this.$store.commit('setTabIdAccountManagement', tab);

      this.$emit("setSeletion", this.item);
    },
    goToMessageScreen() {
      this.$emit("setSeletion", this.item);
    },
    showConfirmationDelete() {
      this.$emit("setSeletion", this.item);

      const payload = {
        EventId: Number(this.item.eventId),
        LanguageTagId: this.$store.getters.getUserLanguage
      };
      dssRequest.doRequest(
        response => {
          console.log("The generic call getEventDetails was successful", response);
          this.eventDetail = CreateEventObject2._createArrayWithObjects(response.data);
          this.deleteText = this.$translate("DELETE_EVENT_NOK");
          this.disableUpdate = true;
          this.eventDetail.memberOf.forEach(e => {
            if (
              e.grantType === "OWNER" &&
              e.accountId == this.currentAccountId
            ) {
              this.deleteText = this.$translate("DELETE_EVENT");
              this.disableUpdate = false;
            }
          });
          this.$emit('deleteElement', {item: this.item, text: this.deleteText, disable: this.disableUpdate});
        },
        error => {
          console.log("The generic call getEventDetails was not successful", error);
          this.eventDetail = BaseObject._toLowerCaseObjectProperties(
            error.data
          );
        },
        "getEventDetailsV2",
        appConfig.dss.eventAdminMng,
        payload
      );
    }
  }
};
</script>

<style scoped>
.entity_list_item {
  border: 1px solid #c0c0c0 !important;
  border-radius: 1em;
}
</style>
